var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.researchPeriod
    ? _c(
        "v-container",
        [
          _c(
            "v-row",
            [
              _c("v-col", { attrs: { cols: "12", "order-md": "2" } }, [
                _c(
                  "div",
                  { staticClass: "d-flex justify-center justify-md-end" },
                  [
                    _c("action-buttons", {
                      staticClass: "d-flex justify-end",
                      attrs: {
                        state: _vm.editState,
                        permissions: _vm.userPermission,
                        disabled: _vm.disableButtons,
                        "is-dirty": _vm.isDirty
                      },
                      on: {
                        save: _vm.handleSave,
                        cancel: _vm.handleCancel,
                        close: _vm.handleClose
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _c(
            "v-form",
            {
              ref: "form",
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Research Period Name",
                          "error-messages": _vm.validation.nameMessage
                        },
                        on: { change: _vm.validate },
                        model: {
                          value: _vm.researchPeriod.name,
                          callback: function($$v) {
                            _vm.$set(_vm.researchPeriod, "name", $$v)
                          },
                          expression: "researchPeriod.name"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "8" } },
                    [
                      _c("div", { staticClass: "text-h6" }, [
                        _vm._v("Dealine Date")
                      ]),
                      _c("v-date-picker", {
                        model: {
                          value: _vm.deadlineDate,
                          callback: function($$v) {
                            _vm.deadlineDate = $$v
                          },
                          expression: "deadlineDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }